import React, {useEffect, useMemo, useState} from 'react';
import {IBreadcrumbItem} from '@fluentui/react';
import {

	useBaselineListPageTranslations,
} from 'features/Baselines/BaselineListPage/BaselinesPage.utils';
import {BaselineCreateDialog} from 'features/Baselines/components/BaselineCreateDialog';

import {NavigateFunction, useNavigate, useParams} from 'react-router-dom';
import {
	BaselineCmdsInfo,
	useBaselineCmds,
} from 'features/Baselines/utils/baselineCmds';
import {useTranslation} from 'react-i18next';

interface IRequirementsBaseline {}

export const paramsRequriementsLibrary = {
	modelSeries: 'Anforderungsbibliothek',
	generation: '-',
};

export const RequirementsBaseline: React.FC<IRequirementsBaseline> = () => {
	const isRequirementsLibrary = true;

	const {infoForIsSuccessDialogOpen}: BaselineCmdsInfo = useBaselineCmds({
		params: paramsRequriementsLibrary,
		isRequirementsLibrary,
		showOverviewCmd: true,
	});

	return (
		<BaselineCreateDialog
			generation={paramsRequriementsLibrary.generation}
			modelSeries={paramsRequriementsLibrary.modelSeries}
			infoForIsOpen={infoForIsSuccessDialogOpen}
		/>
	);
};

export const getIsRequirementLibrary = () =>
	location.pathname.startsWith('/requirements');

export const useBreadcrumbsOfRequirementsLibrarBaselineListPage =
	(): IBreadcrumbItem[] => {
		const {t} = useTranslation('appShell/sidenavigation', {
			keyPrefix: 'SideNavigation',
		});

		const {t: tBaseline} = useBaselineListPageTranslations();
		const navigate: NavigateFunction = useNavigate();

		const breadcrumbs: IBreadcrumbItem[] = [
			{
				text: t('Requirements'),
				key: 'requirements',
				onClick: () => navigate('/requirements'),
			},
			{
				key: 'baselines',
				text: tBaseline('BreadcrumbText'),
			},
		];

		return breadcrumbs;
	};
